import request from '@/utils/request'

// 查询银河打本店铺剧本分页
export function pageShopScript(query) {
  return request({
    url: '/played/shop/script/page',
    method: 'get',
    params: query
  })
}

// 查询银河打本店铺剧本列表
export function listShopScript(query) {
  return request({
    url: '/played/shop/script/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本店铺剧本详细
export function getShopScript(id) {
  return request({
    url: '/played/shop/script/' + id,
    method: 'get'
  })
}

// 新增银河打本店铺剧本
export function addShopScript(data) {
  return request({
    url: '/played/shop/script',
    method: 'post',
    data: data
  })
}

// 修改银河打本店铺剧本
export function updateShopScript(data) {
  return request({
    url: '/played/shop/script',
    method: 'put',
    data: data
  })
}

// 删除银河打本店铺剧本
export function delShopScript(id) {
  return request({
    url: '/played/shop/script/' + id,
    method: 'delete'
  })
}

// 新增银河打本店铺剧本
export function generatePlayedScriptById(id) {
  return request({
    url: '/played/shop/script/generate/' + id,
    method: 'post'
  })
}

export function listAllShopByScriptId(id) {
  return request({
    url: '/played/shop/script/listAllShopByScriptId/' + id,
    method: 'get'
  })
}

export function pageShopScriptV2(query) {
  return request({
    url: '/played/shop/script/pageShopScript',
    method: 'get',
    params: query
  })
}

// 修改银河打本店铺剧本价格
export function editPrices(data) {
  return request({
    url: '/played/shop/script/editPrices',
    method: 'put',
    data: data
  })
}

// 修改银河打本店铺剧本手动调价标识
export function editIsManualPrice(data) {
  return request({
    url: '/played/shop/script/editIsManualPrice',
    method: 'put',
    data: data
  })
}
